import React from 'react';
import { DateInput as MantineDateInput, DateInputProps } from '@mantine/dates';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { IconCalendar } from '@tabler/icons-react';

// Strict format parsing below is a no-op without this plugin, and dayjs then falls back to the
// native Date parser, which reads "15/03/1972" as something else entirely. Registered here so
// the component parses correctly wherever it is mounted, not only under App.
dayjs.extend(customParseFormat);

const DATE_FORMATS = [
  // ISO format
  'YYYY-MM-DD',
  // Common UK date formats
  'DD/MM/YYYY',
  'DD-MM-YYYY',
  'DD.MM.YYYY',
  // Compact UK date formats
  'DDMMYYYY',
  // Two-digit year formats
  'DD/MM/YY',
  'DD-MM-YY',
  'DD.MM.YY',
  'DDMMYY',
];

/**
 * Returns the date string Mantine's own calendar emits, not a Date. `dateParser` feeds `onChange`
 * directly, so returning a Date made a typed entry and a picked one arrive as different types
 * through a prop Mantine declares as `DateStringValue | null` — a caller forwarding the value
 * straight to an API sent a Date, and the type checker had no way to see it.
 */
function parseUKDate(input: string): string | null {
  if (!input?.trim()) return null;
  const trimmed = input.trim();

  for (const format of DATE_FORMATS) {
    const parsed = dayjs(trimmed, format, true);
    if (parsed.isValid()) {
      return parsed.format('YYYY-MM-DD');
    }
  }

  return null;
}

export function DateInput(props: DateInputProps) {
  return (
    <MantineDateInput
      clearable
      placeholder="dd / mm / yyy"
      valueFormat="D MMMM YYYY"
      dateParser={parseUKDate}
      allowDeselect={false}
      leftSection={<IconCalendar />}
      {...props}
    />
  );
}
